var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          {
            staticClass: "news__filters-container col-default-12",
            class: {
              "news__filters-container--open":
                _vm.params.category !== "all" ||
                _vm.params.from ||
                _vm.params.to ||
                _vm.params.type !== "all",
            },
          },
          [
            _c(
              "div",
              { staticClass: "news__filters" },
              [
                _c("z-select", {
                  staticClass: "news__filters-item col-default-4 col-tablet-12",
                  attrs: {
                    data: _vm.newsFilter,
                    value: _vm.params.type,
                    placeholder: _vm.text.filters.type,
                  },
                  on: { change: _vm.selectNews },
                }),
                _vm._v(" "),
                _c("z-select", {
                  staticClass: "news__filters-item col-default-4 col-tablet-12",
                  attrs: {
                    data: _vm.categoryFilter,
                    value: _vm.params.category,
                    placeholder: _vm.text.filters.category,
                  },
                  on: { change: _vm.selectCategory },
                }),
                _vm._v(" "),
                _c("z-date-picker", {
                  staticClass: "news__filters-item col-default-4 col-tablet-12",
                  attrs: { range: "", placeholder: _vm.text.filters.date },
                  on: { change: _vm.selectDate },
                  model: {
                    value: _vm.filterDate,
                    callback: function ($$v) {
                      _vm.filterDate = $$v
                    },
                    expression: "filterDate",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.params.category !== "" ||
            _vm.params.from ||
            _vm.params.to ||
            _vm.params.type !== ""
              ? _c(
                  "button",
                  {
                    staticClass: "news__filters-clear",
                    on: { click: _vm.clearFilters },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.text.filters.reset) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.params.category !== "" ||
        _vm.params.from ||
        _vm.params.to ||
        _vm.params.type !== ""
          ? _c(
              "z-caption",
              {
                staticClass: "news__count col-default-12",
                attrs: { tag: "p", size: "xs" },
              },
              [_vm._v(_vm._s(_vm.text.count) + " " + _vm._s(_vm.nav.count))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.homePage
          ? _c(
              "a",
              {
                staticClass: "news__hero news__hero--figure col-default-12",
                attrs: {
                  href: _vm.isFileCanBeDownloaded
                    ? _vm.homePage.file.link
                    : _vm.homePage.detailPageUrl,
                },
              },
              [
                _c(
                  "big-figure",
                  {
                    staticClass: "news__hero",
                    attrs: {
                      theme: "news",
                      image: _vm.homePage.previewPicture
                        ? _vm.homePage.previewPicture.link
                        : "",
                      "position-x": "left",
                      "position-y": "top",
                    },
                  },
                  [
                    [
                      _c("date-block", {
                        staticClass: "news__date news__date--main",
                        attrs: { size: "l", date: _vm.homePageNewsDate },
                      }),
                      _vm._v(" "),
                      _c(
                        "z-caption",
                        { staticClass: "news__title", attrs: { tag: "h2" } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.homePage.name) +
                              "\n                        "
                          ),
                          _vm.homePage.file.link
                            ? _c("span", { staticClass: "news__hero-tag" }, [
                                _vm._v("PDF"),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "news__tags" },
                        [
                          _vm.homePage.type.value === "Пресс-релиз" ||
                          _vm.homePage.type.value === "Press Release"
                            ? _c(
                                "tag",
                                {
                                  staticClass: "news__tags-item",
                                  attrs: { theme: "peach" },
                                },
                                [_vm._v(_vm._s(_vm.homePage.type.value))]
                              )
                            : _c(
                                "tag",
                                {
                                  staticClass: "news__tags-item",
                                  attrs: { theme: "white" },
                                },
                                [_vm._v(_vm._s(_vm.homePage.type.value))]
                              ),
                          _vm._v(" "),
                          _vm._l(_vm.homePage.category, function (tag, index) {
                            return _c(
                              "tag",
                              {
                                key: index,
                                staticClass: "news__tags-item",
                                attrs: { theme: "white" },
                              },
                              [_vm._v(_vm._s(tag.value))]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.news.length
          ? _c(
              "div",
              [
                _vm._l(_vm.news, function (newsCard, index) {
                  return _c("news-card", {
                    key: index,
                    attrs: { newsInfo: newsCard },
                  })
                }),
                _vm._v(" "),
                _c("z-pagination", {
                  staticClass: "news__pagination",
                  attrs: {
                    "show-next": "",
                    "show-prev": "",
                    data: {
                      currentPage: _vm.nav.current,
                      totalItems: _vm.nav.count,
                      totalPages: _vm.nav.total,
                      pageRange: 1,
                    },
                  },
                  on: { change: _vm.loadAnotherPage },
                }),
              ],
              2
            )
          : _c(
              "z-not-found",
              [
                [
                  _c(
                    "z-caption",
                    {
                      staticClass: "news__title news__title--not-found",
                      attrs: { tag: "h2" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.text.notFound.title) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    { staticClass: "news__text", attrs: { tag: "p" } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.text.notFound.text) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
              ],
              2
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }